import { ModulesMap } from '@/config/data/modulesMaps'

import ApiModule from '@/services/apiModule.js'

export default class EquipmentApi extends ApiModule {
	constructor() {
		super(ModulesMap.EQUIPMENT, {
			entity: 'equipment',
		})
	}
}
